import { ReactElement } from 'react';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';

const MetaWishList = (): ReactElement => {
    const rootUrl = buildRootUrl('/wishlist/');
    return (
        <CommonMeta
            title="Wish List - TripShock!"
            description="Fill your TripShock trip wishlist to begin planning your dream vacation."
            canonical={rootUrl}
            imageSrc={''}
            slug={''}
            ogUrl={rootUrl}
        />
    );
};

export { MetaWishList };
export default MetaWishList;
